var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "followUpRecord" },
    [
      _vm.addRecordShow
        ? _c("record-upload", {
            attrs: { "form-info": _vm.formInfo },
            on: { change: _vm.uploadChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "recordContent" },
        [
          _c(
            "el-timeline",
            _vm._l(_vm.dynamicRecord, function (activity, index) {
              return _c(
                "el-timeline-item",
                {
                  key: index,
                  attrs: {
                    icon: activity.icon,
                    size: activity.size,
                    type: String(activity.type),
                    color: "#1890FF",
                  },
                },
                [
                  activity.types === 1
                    ? _c("div", [
                        _c("div", { staticClass: "head" }, [
                          _c("div", { staticClass: "head-right" }, [
                            _c("span", { staticClass: "head-name" }, [
                              _vm._v(_vm._s(_vm.getTypeStr(activity.type))),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "head-time" }, [
                              _vm._v(_vm._s(activity.created_at)),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "record" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(activity.reason) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        activity.time
                          ? _c("div", { staticClass: "reminderTime" }, [
                              _c("img", {
                                staticClass: "zhong",
                                attrs: {
                                  alt: "",
                                  src: require("../../../../assets/images/zhong.png"),
                                },
                              }),
                              _vm._v(
                                " 提醒时间：" +
                                  _vm._s(activity.created_at) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _c(
                        "div",
                        [
                          _vm.editIndex !== index
                            ? _c(
                                "div",
                                [
                                  _c("div", { staticClass: "head" }, [
                                    _c("div", { staticClass: "head-right" }, [
                                      _c("span", { staticClass: "head-name" }, [
                                        _vm._v(
                                          _vm._s(
                                            activity.creator
                                              ? activity.creator.name
                                              : "--"
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "head-time" }, [
                                        _vm._v(
                                          _vm._s(
                                            activity.creator
                                              ? activity.creator.name
                                              : "--"
                                          ) +
                                            " | " +
                                            _vm._s(activity.created_at)
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "record" }, [
                                    _c("span", { staticClass: "c-30" }, [
                                      _vm._v("说明："),
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(activity.reason || "--")
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    activity.attachs,
                                    function (fileItem, g) {
                                      return _c(
                                        "div",
                                        { key: g, staticClass: "flex" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "fileItem" },
                                            [
                                              _vm.toSrc(fileItem.name) === 1
                                                ? _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      alt: "",
                                                      src: require("../../../../assets/images/doc.png"),
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.toSrc(fileItem.name) === 2
                                                ? _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      alt: "",
                                                      src: require("../../../../assets/images/ppt.png"),
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.toSrc(fileItem.name) === 3
                                                ? _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      alt: "",
                                                      src: require("../../../../assets/images/xls.png"),
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.toSrc(fileItem.name) === 5
                                                ? _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      alt: "",
                                                      src: require("../../../../assets/images/pdf.png"),
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.toSrc(fileItem.name) === 4
                                                ? _c("img", {
                                                    staticClass: "img",
                                                    attrs: {
                                                      alt: "",
                                                      src: require("../../../../assets/images/record2.png"),
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(fileItem.real_name) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "mt10" }, [
                                            _vm.toSrc(fileItem.name) === 4
                                              ? _c("span", {
                                                  staticClass:
                                                    "iconfont iconyulan pointer",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handlePictureCardPreview(
                                                        fileItem.url
                                                      )
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "iconfont iconxiazai pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.downloadFile(
                                                    fileItem.url,
                                                    fileItem.real_name
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.editIndex === index
                            ? _c("record-upload", {
                                attrs: { "form-info": _vm.formInfo },
                                on: { change: _vm.uploadChange },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.dynamicRecord.length == 0
        ? _c("div", { staticClass: "default" }, [
            _c("img", {
              staticClass: "img",
              attrs: {
                alt: "",
                src: require("../../../../assets/images/def1.png"),
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.$t("public.message14") + "~")),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isImage
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.closeImageViewer,
              "url-list": _vm.srcList,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("remind-dialog", {
        ref: "remindDialog",
        attrs: { config: _vm.remindConfig },
        on: { change: _vm.remindChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }